import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import { Link } from 'react-router-dom';

import { commonStyles, COLORS } from '../styles/styles';
import logo from '../assets/logo.svg';
import logoWide from '../assets/cs_logo.png';

const Logo = ({ classes, className = {}, wideLogo }) => (
  <div className={`${classes.wrapper} ${className}`}>
    <Link to="/" className={`${wideLogo ? classes.logoWide : classes.logoBackground}`}>
      <img
        alt="logo"
        src={wideLogo ? logoWide : logo}
        className={`${!wideLogo ? classes.image : classes.imageWide}`}
      />
    </Link>
  </div>
);

Logo.propTypes = {
  classes: PropTypes.instanceOf(Object),
  className: PropTypes.string,
  wideLogo: PropTypes.bool,
};

const styles = theme => ({
  ...commonStyles,
  image: {
    flexGrow: 1,
    width: 30,
    height: 45,
  },
  logoBackground: {
    width: 425,
    height: 45,
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
  },
  wrapper: {
    position: 'absolute',
    zIndex: theme.zIndex.appBar + 1,
  },
  logoWide: {
    //width: '40%',
     height: 45,
    // display: 'flex',
  },
  imageWide: {
    //width: '40%',
    // flex: 1,
    // width: 172,
     height: 45,
  },
});

export default withStyles(styles)(Logo);



// WEBPACK FOOTER //
// ./src/Components/Logo.jsx